import APIService from './APIService'

const api = APIService()

export const fetchUserRoles = () => api.get('/dictionaries/roles')
export const fetchZones = () => api.get('/dictionaries/zones')
